enum coachtDirectoryEndpoints {
  PROFILE_DATA = '/coaches/',
  APPROVE_REJECT = '/coach-requests/',
}
export default coachtDirectoryEndpoints;
